<!-- 支付电费详情 -->
<template>
    <div class="playElectricityBill">

        <van-form @submit="onSubmit" class="form">
            <van-field class="inputBox" v-model="playMoneyFrom.userName" name="ammeter" label="收款方名称：" disabled />
            <van-field class="inputBox" v-model="playMoneyFrom.playType" name="ammeter" label="缴费类型：" disabled />
            <van-field class="inputBox" v-model="playMoneyFrom.user" name="ammeter" label="缴费用户：" disabled />
            <van-field class="inputBox" v-model="playMoneyFrom.card" name="ammeter" label="缴费户号：" disabled />
            <van-field class="inputBox" v-model="playMoneyFrom.money" name="ammeter" label="充值金额："
                placeholder="请输入要充值的金额"  required/>
            <van-field class="inputBox" v-model="playMoneyFrom.remark" name="ammeter" label="备注："
                placeholder="请输入备注内容"  />
            <van-button class="btnBox" round block type="info" native-type="submit" >充值</van-button>
        </van-form>
    </div>
</template>

<script>

export default {
    components: {},
    data() {
        return {
            playMoneyFrom: {
                userName: '杨先生',
                playType: '充值',
                user: '1#222',
                card: 'HH122223365',
                money: '',
                remark: '',
            }
        };
    },
    created() { },
    mounted() { },
    methods: {
        onSubmit() {
            if (this.playMoneyFrom.money == '') {
                    this.$toast('请输入要充值的金额')
                    return
            }

        }
    },
}
</script>

<style lang="less" scoped>
.playElectricityBill {
    .form{
        .btnBox{
            width: 10rem;
            margin: 1rem auto;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/electricCharge/playElectricityBill.vue